import { gql } from '@apollo/client';
import { graphql } from '@lib/api';
import { AGENT_BY_ID_QUERY_SHORT } from '@lib/fragments';

export const fetchAssociatedAgent = async (variables = {}) => {
  try {
    return await execAssociatedAgentQuery(variables);
  } catch (error) {
    throw new Error(`Error fetching agent data: ${error}`);
  }
};

export const execAssociatedAgentQuery = async (variables = {}) => {
  return await graphql(
    gql`
      ${AGENT_BY_ID_QUERY_SHORT}
    `,
    variables
  );
};

export const getAssociatedAgentItem = (data) => {
  if (typeof data?.agentSearch?.items[0] !== 'undefined' && data?.agentSearch?.items[0] != null) {
    return data?.agentSearch?.items[0];
  }
  return null;
};
